import { Ng1Component } from 'core/common/decorators/Ng1Component';

require('./filtered-select.scss');

@Ng1Component({
    moduleNamespace: 'eservice.core',
    module: 'components.filtered-select',
    moduleDependencies: [],
    name: 'epit-filtered-select',
    cacheTemplates: {
        "selectize/no-choice.tpl.html": require('./no-choice.tpl.html'),
        "selectize/choices.tpl.html": require('./choices.tpl.html')
    },
    template: `
        <ui-select
            ng-model="ctrl.currentSelection"
            theme="selectize"
            ng-disabled="ctrl.disabled"
            on-select="ctrl.doOnSelect($item)"
            title="{{ctrl.currentSelection.label}}"
        >
            <ui-select-match placeholder="{{ctrl.placeholderValue}}">
                <span class="selectize__value">
                    <span class="selectize__name">{{$select.selected.label}}</span>
                    <span ng-if="$select.selected.meta">&nbsp;|&nbsp;{{$select.selected.meta}}</span>
                </span>
            </ui-select-match>
            <ui-select-choices group-by="'group'" repeat="option in ctrl.normalizedOptions | filter: $select.search track by $index">
                <span ng-bind-html="ctrl.$sce.trustAsHtml((option.label | highlight: $select.search))"></span>
            </ui-select-choices>
            <ui-select-no-choice translate="ctrl.noMatchesKey"></ui-select-no-choice>
        </ui-select>
    `,
    bindings: {
        options: '<',
        initialOption: '<',
        disabled: '<',
        onSelect: '&',

        optionLabelField: '@',
        optionMetaField: '@',
        optionGroupByField: '@',

        noMatchesKey: '@',
        placeholderKey: '@'
    }
})
export class FilteredSelectComponent<ITEM> {
    static $inject = ['$sce', 'translator'];

    constructor(protected $sce: ng.ISCEService, private translator: Translator) {
    }

    options: ITEM[];
    initialOption: ITEM;
    onSelect: (params: { item: ITEM }) => void;

    optionLabelField: string;
    optionMetaField: string;
    optionGroupByField: string;

    placeholderKey: string;
    placeholderValue: string;

    currentSelection: NormalizedOption<ITEM>;
    normalizedOptions: NormalizedOption<ITEM>[];

    $onInit() {
        this.initPlaceholder();
        this.initOptions();
    }

    private langChangeBinding: Binding;

    private initPlaceholder() {
        this.placeholderValue = this.translator.translate(this.placeholderKey);
        this.langChangeBinding = this.translator.bind(this.translator.Event.LANGUAGE_CHANGED, () => {
            this.placeholderValue = this.translator.translate(this.placeholderKey);
        })
    }

    $onDestroy() {
        if (!!this.langChangeBinding)
            this.langChangeBinding.unbind();
    }

    $onChanges(changes) {
        this.initOptions();
    }

    private initOptions() {
        this.currentSelection = !this.initialOption ? null : this.normalizeOption(this.initialOption);

        this.normalizedOptions = this.options
            .map(item => this.normalizeOption(item));
    }

    doOnSelect(option: NormalizedOption<ITEM>) {
        this.onSelect({item: option.item});
    }

    private normalizeOption(item: ITEM): NormalizedOption<ITEM> {
        return {
            item,
            label: item[this.optionLabelField],
            meta: item[this.optionMetaField],
            group: this.optionGroupByField ? item[this.optionGroupByField] : null
        };
    }
}

interface NormalizedOption<ITEM> {
    item: ITEM;
    label: string;
    meta: string;
    group: string;
}


// WEBPACK FOOTER //
// ./src/ui/core/common/components/filtered-select/filtered-select.component.ts